<template>
    <AppLayout v-bind="appSharedData.getAppSidebarLayoutProps(pageMeta)">
        <AvailabilityDetailsSection
            :availability="localAvailability"
            :companyUser="authCompanyUser"
        />
        <template v-if="props.hasAvailabilityNaturalLanguageParsingFeatureFlag">
            <SideFormSectionDivider />
            <AvailabilityAiSection
                :availability="localAvailability"
                :companyUser="authCompanyUser"
                @onSuccess="handleAvailabilityUpdated"
            />
        </template>
        <SideFormSectionDivider />
        <AvailabilityWeeklyHoursSection
            :key="availabilityHoursSectionKey"
            :availability="localAvailability"
            :companyUser="authCompanyUser"
        />
        <SideFormSectionDivider />
        <AvailabilityDateSpecificHoursSection
            :key="availabilityHoursSectionKey"
            :availability="localAvailability"
            :companyUser="authCompanyUser"
        />
        <PageBottomPadding />
    </AppLayout>
</template>

<script setup lang="ts">
    import { ref } from 'vue'
    import AppLayout from '@/Shared/Layout/App/Sidebar/AppLayout.vue'
    import SideFormSectionDivider from '@/Shared/Component/SideFormSectionDivider.vue'
    import Availability from '@/App/Availability/Entity/Availability'
    import AvailabilityAiSection from '@/App/Availability/Component/AvailabilityAiSection.vue'
    import AvailabilityDetailsSection from '@/App/Availability/Component/AvailabilityDetailsSection.vue'
    import AvailabilityWeeklyHoursSection from '@/App/Availability/Component/AvailabilityWeeklyHoursSection.vue'
    import AvailabilityDateSpecificHoursSection from '@/App/Availability/Component/AvailabilityDateSpecificHoursSection.vue'
    import PageBottomPadding from '@/Shared/Layout/App/Sidebar/PageBottomPadding.vue'
    import { type PageMeta } from '@/Shared/AutoGenerated/Main'
    import AppSharedData from '@/Shared/Entity/AppSharedData'

    interface AvailabilityEditPageProps {
        pageMeta: PageMeta
        appSharedDataData: any
        availabilityData: any
        hasAvailabilityNaturalLanguageParsingFeatureFlag: boolean
    }

    const props = defineProps<AvailabilityEditPageProps>()
    const appSharedData = AppSharedData.hydrate(props.appSharedDataData)
    const authCompanyUser = appSharedData.getAuthCompanyUser()
    const localAvailability = ref<Availability>(
        Availability.hydrateSingle(props.availabilityData),
    )
    const availabilityHoursSectionKey = ref<number>(0)

    function handleAvailabilityUpdated(availability: Availability): void {
        localAvailability.value = availability
        availabilityHoursSectionKey.value += 1
    }
</script>
